module.exports = __webpack_public_path__ + "static/nad_1-397a74f37a83005681ee2897a1692288.png";